import { render } from "./SwitchLang.vue?vue&type=template&id=3d13b452"
import script from "./SwitchLang.vue?vue&type=script&lang=js"
export * from "./SwitchLang.vue?vue&type=script&lang=js"

import "./SwitchLang.vue?vue&type=style&index=0&id=3d13b452&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__